const XcloseIcon = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--x';
  color = color || '#323130';

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path d="M4 12L12 4M4 4L12 12" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default XcloseIcon;
